import { Directive, Input, inject } from '@angular/core'
import { ElderSelectComponent, Sort } from '@elderbyte/ngx-starter'
import { PrinterFilter, PrinterService } from './printer.service'
import { LoggerFactory } from '@elderbyte/ts-logger'

@Directive({
  selector: '[appPrinterSelect]',
})
export class PrinterSelectDirective {
  private select = inject(ElderSelectComponent)
  private printerService = inject(PrinterService)

  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.select.icon = 'printer'
    this.select.displayProperty = 'description'
    this.select.placeholder = 'printers.printer'
    this.select.dataSource = this.printerService
    this.select.pageSize = 15
    this.select.sorts = [new Sort('name', 'asc')]
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set filterFacility(facility: string) {
    this.log.info('Filter facility: ' + facility, this.select)
    this.select.filters = [PrinterFilter.facility(facility)]
  }
}
